import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentService } from '@common/services/content.service';
import { RegistrationService } from '@enus/services/registration.service';
import { EnUsCommunityService } from '@enus/services/enus-community.service';

@Component({
    selector: 'app-hero-image',
    templateUrl: './hero-image.component.html',
    styleUrls: ['./hero-image.component.scss'],
    standalone: false
})
export class HeroImageComponent implements OnInit, OnDestroy {
    private destroyed$ = new Subject<void>();

    participantCount$: Observable<number>;
    hero: string;
    logosCmsKeys$: Observable<string[]>;

    public infoBullets = [
        { id: 1, routerLink: '../info/why-should-i-switch' },
        { id: 2, routerLink: '../register' },
        { id: 3, routerLink: '../info/auction' }
    ];

    private logoCmsKeyBase = 'past-winning-supplier-logo';

    constructor(
        private service: RegistrationService,
        private contentService: ContentService,
        public communityService: EnUsCommunityService
    ) { }

    ngOnInit() {
        this.participantCount$ = this.service.count();

        this.contentService.value('hero-image')
            .pipe(
                takeUntil(this.destroyed$)
            )
            .subscribe(url => this.hero = url);
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
